// extracted by mini-css-extract-plugin
module.exports = {"cookieBanner":"banner-module--cookie-banner--Zh-ZG","cookieWrapper":"banner-module--cookie-wrapper--2nmPO"};